import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface CartOrderAlertEntityParams {
  alert_type: string;
}
export class CartOrderAlertEntity extends BaseEntityClass {
  alert_type: string;
  constructor(params: CartOrderAlertEntityParams) {
    super();
    this.type = "cart_order_alert";
    this.entity_version = 2;
    this.alert_type = params.alert_type;
  }
}
